import { useRef, type CSSProperties, type ReactNode } from "react";
import { cn } from "@/lib/utils";
import { useInViewOnce } from "@/hooks/use-in-view-once";
import { usePrefersReducedMotion } from "@/hooks/use-prefers-reduced-motion";

export function Reveal({
  children,
  delay = 0,
  y = 28,
  className,
}: {
  children: ReactNode;
  delay?: number;
  y?: number;
  className?: string;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const reduced = usePrefersReducedMotion();
  const inView = useInViewOnce(ref);
  const visible = reduced || inView;

  return (
    <div
      ref={ref}
      className={cn("reveal-up", visible && "is-in", className)}
      style={
        {
          "--reveal-delay": `${delay}s`,
          "--reveal-y": `${y}px`,
        } as CSSProperties
      }
    >
      {children}
    </div>
  );
}

export function MaskReveal({
  children,
  delay = 0,
  className,
}: {
  children: ReactNode;
  delay?: number;
  className?: string;
}) {
  const ref = useRef<HTMLSpanElement>(null);
  const reduced = usePrefersReducedMotion();
  const inView = useInViewOnce(ref);
  const visible = reduced || inView;

  return (
    <span
      ref={ref}
      className={cn("reveal-mask", visible && "is-in", className)}
      style={{ "--reveal-delay": `${delay}s` } as CSSProperties}
    >
      <span className="reveal-mask-inner">{children}</span>
    </span>
  );
}

export function Eyebrow({ children, tone = "dark" }: { children: ReactNode; tone?: "dark" | "light" }) {
  return (
    <p
      className={`eyebrow ${tone === "light" ? "text-primary-foreground/75" : "text-muted-foreground"}`}
    >
      {children}
    </p>
  );
}
